import React from 'react';
import styles from  './gamePreview.module.css';
import logo from '../../assets/mtc logo.png';
import { Round } from '../../types/Round';
import defaultPic from '../../assets/avatar.png';
import GameRules from '../../components/GameRules';
import { backendClient } from '../../services/MtcBackendClient';
import { Category } from '../../types/Category';
import LoadingContext from '../../contexts/LoadingContext';
import ToastContext from '../../contexts/ToastContext';
import { parseError } from '../../utils/errorUtils';


export interface GamePreviewScreenProps{
    round?: Round;
}

const GamePreviewScreen: React.FC<GamePreviewScreenProps> = ({ round })=>{

    // Context
    const { setLoading } = React.useContext(LoadingContext)
    const { openError } = React.useContext(ToastContext)

    // State
    const [category, setCategory] = React.useState<Category>();

    // Helpers
    const fetchCategory = async (id: number)=>{
        try {
            let data = await backendClient.fetchCategoryById(id ,setLoading);
            console.log(data.data);
            setCategory(data.data);
        } catch (error) {
            setLoading(false)
            console.log(error);
            openError(parseError(error as any))
        }
    }

    // Effect
    React.useEffect(()=>{
        if (round?.categoryId) {
            fetchCategory(round.categoryId)
        }
    },[round])

    // Elements
    const mtclogo = (
        <div className={styles.logo}>
            <img src={logo} alt="MTC logo" />
        </div>
    );

    const displayPicture = (
        <img src={round?.player && round?.player.image ? round.player.image.url : defaultPic} 
        alt="MTC Contestant image" />
    )

    return (
        <div className={styles.container}>
            { !round && mtclogo }
            { 
                round &&
                <div className={styles.previewContainer}>
                    
                    {/** Player Details */}
                    <div className={styles.profileContainer}>
                        <div className={styles.profileImg} >
                            { displayPicture }
                        </div>
                        <div className={styles.name}>
                            <p>{`${round?.player?.firstname} \n`}</p>
                            <p>{`${round?.player?.lastname}`}</p>
                            <hr />
                            {round?.player?.grade} GRADE
                        </div>
                    </div>

                    {/** Challenge Details */}
                    <div className={styles.challengeDetails}>
                        <GameRules 
                            rule={round?.rule} 
                            displayOnly
                            mode={round?.mode}
                        />

                        <div className={styles.challengeDisplay}>
                            <p className={styles.challengeTitle}>
                                { category?.name }
                            </p>
                            <hr />
                            <div>
                                <pre style={{ whiteSpace: 'pre-line' }}>
                                    <span style={{ fontSize: 20 }}>
                                        {category?.description}
                                    </span>
                                </pre>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </div>
    )
   
}

export default GamePreviewScreen;